import React, { useState } from "react";
import { Container, Row } from "react-bootstrap";
import axios from "axios";
import "../../style.css";

const ContactForm = () => {
    const [status, setStatus] = useState(null)
    const [sending, setSending] = useState(false)
    const [email, setEmail] = useState("")
    const [vorname, setVorname] = useState("")
    const [text, setText] = useState("")
    const [betreff, setBetreff] = useState("")
    const [fax, setFax] = useState("")

    const handleSubmit = async event => {
      event.preventDefault()
      setSending(true)
      setStatus(null)

      try {
        const response = await axios.post("/api/contact", {
          email,
          vorname,
          betreff,
          text,
          fax
        }, {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        })

        if (response.status === 200) {
          setEmail("")
          setVorname("")
          setText("")
          setBetreff("")
          setFax("")
          setStatus("SUCCESS")
        }
      } catch (err) {
        setStatus(err.response?.status === 429 ? "RATELIMIT" : "ERROR")
      } finally {
        setSending(false)
      }
    }

    return (
        <Container id="contactform">
            <Container>
              <Row>
            <div className="Contact">
              <section>
                {status === "ERROR" && (
                  <>
                    <h1>Oops, ein Problem ist aufgetreten..</h1>
                    <p>
                      Überprüfe deine Eingaben und probiere es erneut
                    </p>
                  </>
                )}
                {status === "RATELIMIT" && (
                  <>
                    <h1>Zu viele Anfragen</h1>
                    <p>
                      Bitte warte einen Moment und versuche es dann erneut.
                    </p>
                  </>
                )}
                {status === "SUCCESS" && (
                  <>
                  <br></br>
                    <p style={{ fontSize: "1.5em" }}><b>Vielen Dank für deine Kontaktanfrage!</b></p>
                  </>
                )}
                <div>
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="Vorname"
                    value={vorname}
                    onChange={event => setVorname(event.target.value)}
                    required
                    maxLength={80}
                  />
                  <br></br>
                  <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    required
                    maxLength={254}
                  />
                  <br/>
                  <input
                    type="text"
                    placeholder="Betreff"
                    value={betreff}
                    onChange={event => setBetreff(event.target.value)}
                    required
                    maxLength={120}
                  />
                  <br/>
                  <textarea rows={4} cols={40}
                    placeholder="Text"
                    value={text}
                    onChange={event => setText(event.target.value)}
                    required
                    maxLength={5000}
                  />
                  <div className="hp-field" aria-hidden="true">
                    <label htmlFor="fax">Fax</label>
                    <input
                      id="fax"
                      type="text"
                      name="fax"
                      tabIndex={-1}
                      autoComplete="off"
                      value={fax}
                      onChange={event => setFax(event.target.value)}
                    />
                  </div>
                  <br />
                  <button fluid="true" className="button" disabled={sending}>
                    {sending ? "Wird gesendet…" : "Abschicken"}
                  </button>
                  </form>
                </div>
              </section>
            </div>
            </Row>
            </Container>
          </Container>
    )

}

export default ContactForm
